import React from 'react';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import useProducts from '../../hooks/useProducts';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { toggleCompareItem } from '../../redux/slices/compareSlice';
import SingleShop from '../../components/Shop';

const ShopArea = () => {
  // Use the custom hook to fetch product data and manage loading/error states
  const { products, status, error } = useProducts();
  const dispatch = useDispatch();

  // Dispatch the action to add the item to cart
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  // Dispatch the action to toggle the item to the wishlist
  const handleToggleWishlist = (product) => {
    dispatch(toggleWishlistItem(product));
  };

  // Dispatch the action to toggle the item to the Compare
  const handleToggleCompare = (product) => {
    dispatch(toggleCompareItem(product));
  };

  // Slider settings for handling swiper slide
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: 4,
    spaceBetween: 35,
    autoplay: false,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };

  // Render a loading message while the products are being fetched
  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  // Render an error message if the fetch request fails
  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="it-shop-area fix pb-90">
      <div className="container">
        <div className="it-shop-title-wrap mb-65">
          <div className="row align-items-end">
            <div className="col-xl-6 col-md-6">
              <div className="it-shop-title-box">
                <h3 className="it-section-title">Related Products</h3>
              </div>
            </div>
            <div className="col-xl-6 col-md-6">
              <div className="it-shop-arrow-box text-md-end">
                <button className="slider-prev">
                  <span>
                    <i className="fa-regular fa-angle-left"></i>
                  </span>
                </button>
                <button className="slider-next">
                  <span>
                    <i className="fa-regular fa-angle-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-shop-slider-wrap">
              <div className="swiper-container">
                <Swiper
                  modules={[Navigation]}
                  {...sliderOption}
                  className="swiper-wrapper it-shop-active"
                >
                  {products.map((product) => (
                    <SwiperSlide key={product.id} className="swiper-slide">
                      <SingleShop
                        productId={product.id}
                        thumbnailImg={product.thumbnail}
                        badgeTitle={product.badgeTitle}
                        title={product.title}
                        price={product.price}
                        rating={product.rating}
                        category={product.category}
                        images={product.images}
                        inStock={product.inStock}
                        onAddToCart={() => handleAddToCart(product)}
                        onToggleWishlist={() => handleToggleWishlist(product)}
                        onToggleCompare={() => handleToggleCompare(product)}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopArea;
